import { Fragment } from 'react';
import { DeliveryAddressInput } from '../../types/api';

interface Props {
  readonly address: DeliveryAddressInput;
  /** Start with the recipient's name (omit it when the caller shows it separately). */
  readonly withRecipient?: boolean;
}

/** A postal address as line-broken text; the caller supplies the wrapping element. */
export default function AddressLines({ address, withRecipient = false }: Props) {
  const lines = [
    withRecipient ? address.recipient_name : null,
    address.phone_number,
    address.address_line_1,
    address.address_line_2,
    `${address.city}, ${address.state} ${address.postal_code}`,
    'India',
  ].filter(Boolean);
  return (
    <>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {index > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </>
  );
}
